import { derivedStream, dispatchAction } from '@ardoq/rxbeach';
import { map } from 'rxjs';
import { appModelStateEdit$ } from 'appModelStateEdit/appModelStateEdit$';
import { GetContentOptionsType } from 'appModelStateEdit/legacyTypes';
import { AppModelStateEditStreamShape } from 'appModelStateEdit/types';
import { hideRightPane } from 'appContainer/actions';
import { activateComponentFab } from './actions';
import { fabVisibility$ } from '../fabVisibility$';
import { isViewpointMode$ } from 'traversals/loadedGraph$';
import { featureContext$ } from 'streams/featureContext$';
import { Features, FeatureContext, featureOperations } from '@ardoq/features';
import { requestOpenCreateComponentDialog } from 'createComponentDialog/createComponentDialogActions';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { type I18nLocale } from '@ardoq/i18n';

const getOnClick = (
  isActive: boolean,
  isViewpointMode: boolean,
  featureContext: FeatureContext
): VoidFunction => {
  if (isActive) {
    return () => dispatchAction(hideRightPane());
  }
  if (
    isViewpointMode &&
    featureOperations.hasFeature(featureContext, Features.CANVAS_PROTOTYPE)
  ) {
    // KFQ12026
    return () => dispatchAction(requestOpenCreateComponentDialog());
  }
  return () => dispatchAction(activateComponentFab());
};

const toComponentFabStream = ([
  isVisible,
  { options },
  { isViewpointMode },
  featureContext,
  i18nLocale,
]: [
  boolean,
  AppModelStateEditStreamShape,
  { isViewpointMode: boolean },
  FeatureContext,
  I18nLocale,
]) => {
  const isActive = options.type === GetContentOptionsType.CREATE_COMPONENT;
  return {
    isActive,
    isVisible,
    i18nLocale,
    onClick: getOnClick(isActive, isViewpointMode, featureContext),
  };
};

const componentFab$ = derivedStream(
  'componentFab$',
  fabVisibility$,
  appModelStateEdit$,
  isViewpointMode$,
  featureContext$,
  i18nLocale$
).pipe(map(toComponentFabStream));

export { componentFab$ };
